@if (customerNumber) {
  <div>
    @if (isCompany || isReseller) {
      <hr class="w-full my-2" />
      <div class="flex justify-between max-lg:mb-4">
        <h2>Primary Contact</h2>
        @if (showEditPrimaryInfoButton) {
          <div class="grid grid-cols-1 gap-4 place-content-center">
            @if ((primaryContactError$ | async) === undefined) {
              <ss-button
                (click)="editPrimaryContact()"
                [disabled]="!can('update', 'customer:additional-contact')"
                >Edit Primary Contact</ss-button
              >
            }
          </div>
        }
      </div>
      @if (primaryContactError$ | async) {
        <div class="mb-8">
          <label class="text-ss-error">No primary contact found.</label>
        </div>
      }
      @if ((primaryContactError$ | async) === undefined) {
        @if (primaryContact$ | async; as primaryContact) {
          <div class="grid grid-cols-3 flex-1">
            <div class="my-8">
              <h3>Phone Number</h3>
              <div class="items-center">
                <span>{{
                  primaryContact.phoneNumber | phone | nullFormatter
                }}</span>
              </div>
            </div>
            <div class="my-8">
              <h3>Full Name</h3>
              <div class="items-center">
                <span data-test="primary-contact-name">
                  {{ primaryContact.firstName | titlecase }}
                  {{ primaryContact.lastName | namecase | nullFormatter }}
                </span>
              </div>
            </div>
            <div class="my-8">
              <h3>Email Address</h3>
              <div class="items-center">
                <span>{{ primaryContact.emailAddress | nullFormatter }}</span>
              </div>
            </div>
          </div>
        }
      }
    }
  </div>
}
